module.exports = "/images/vendor/flag-icon-css/flags/4x3/mm.svg?92e9f832a28fd293035e21d9b6983790";